/**

 * VAGO Cloud · storefront event tracking (6B + 4B)

 */

(function () {

  'use strict';



  var cfg = window.VAGO_TRACK || {};

  var endpoint = cfg.endpoint || '';

  var store = cfg.store || '';

  var enabled = cfg.enabled !== false && !!endpoint;

  var minViewers = cfg.minViewers || 2;



  if (!enabled) return;



  var sidKey = 'vago_sid';

  var sid = sessionStorage.getItem(sidKey);

  if (!sid) {

    sid = 's_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);

    sessionStorage.setItem(sidKey, sid);

  }



  function payload(name, data) {

    return {

      event: name,

      store: store,

      session_id: sid,

      path: location.pathname,

      url: location.href,

      ts: new Date().toISOString(),

      data: data || {},

    };

  }



  function send(name, data) {

    var body = JSON.stringify(payload(name, data));

    if (navigator.sendBeacon) {

      try {

        var blob = new Blob([body], { type: 'application/json' });

        if (navigator.sendBeacon(endpoint, blob)) return;

      } catch (e) { /* fall through */ }

    }

    fetch(endpoint, {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: body,

      keepalive: true,

      credentials: 'omit',

    }).catch(function () {});

  }



  function showViewCount(viewsEl, count) {

    if (!viewsEl || !count || count < minViewers) return;

    var textEl = viewsEl.querySelector('.vc-product-views__text');

    if (!textEl) return;

    textEl.textContent = count + ' personas están viendo este producto';

    viewsEl.hidden = false;

  }



  function trackProductView() {

    var viewsEl = document.querySelector('.vc-product-views[data-vc-product-id]');

    if (!viewsEl) return;



    var productId = String(viewsEl.getAttribute('data-vc-product-id') || '');

    if (!productId) return;



    fetch(endpoint, {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify(payload('view_item', { product_id: productId })),

      credentials: 'omit',

    })

      .then(function (res) { return res.ok ? res.json() : null; })

      .then(function (data) {

        if (data && typeof data.view_count === 'number') {

          showViewCount(viewsEl, data.view_count);

        }

      })

      .catch(function () {});

  }



  window.vagoTrack = send;



  if (cfg.autoPageView !== false) {

    send('page_view', { title: document.title });

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', trackProductView);

  } else {

    trackProductView();

  }



  document.addEventListener('click', function (ev) {

    var el = ev.target && ev.target.closest

      ? ev.target.closest('[data-vago-event], .sticky-atc, [name="add"], button[type="submit"][form*="product"]')

      : null;

    if (!el) return;

    var name = el.getAttribute('data-vago-event');

    if (!name) {

      if (el.classList && el.classList.contains('sticky-atc')) name = 'sticky_atc_click';

      else if (el.getAttribute('name') === 'add') name = 'add_to_cart';

    }

    if (!name) return;

    send(name, {

      product_id: el.getAttribute('data-product-id') || undefined,

      variant_id: el.getAttribute('data-variant-id') || undefined,

    });

  }, true);



  document.addEventListener('submit', function (ev) {

    var form = ev.target;

    if (!form || !form.action) return;

    if (form.action.indexOf('/cart/add') !== -1) {

      send('add_to_cart', { form_action: form.action });

    }

  }, true);

})();

